var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgOptions = function SvgOptions(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 8 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.755 22.75c0-1.795 1.466-3.25 3.275-3.25 1.81 0 3.276 1.455 3.276 3.25S5.839 26 4.03 26C2.221 26 .755 24.545.755 22.75ZM.755 13c0-1.795 1.466-3.25 3.275-3.25 1.81 0 3.276 1.455 3.276 3.25s-1.467 3.25-3.276 3.25C2.221 16.25.755 14.795.755 13ZM.755 3.25C.755 1.455 2.22 0 4.03 0c1.81 0 3.276 1.455 3.276 3.25S5.839 6.5 4.03 6.5C2.221 6.5.755 5.045.755 3.25Z",
    fill: "currentColor"
  })));
};
export default SvgOptions;